import * as React from 'react';
import { ArrowLeft, RefreshCw } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { SchedulePublisher } from './components/SchedulePublisher';
import { ScheduleResults } from './components/ScheduleResults';
import { useScheduleData, useScheduleDataActions } from './state';

export function ScheduledBusesPage() {
  const snapshot = useScheduleData((value) => value);
  const actions = useScheduleDataActions();
  React.useEffect(() => {
    actions.loadView();
  }, []);
  const loading = snapshot.matches('loading') || snapshot.matches('refreshing');
  const error = snapshot.matches('error');
  return (
    <main className="mx-auto w-full max-w-5xl px-5 py-10 sm:py-14">
      <header className="flex flex-col gap-5 border-b border-border pb-8 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="font-heading text-3xl font-semibold tracking-[-0.03em] sm:text-4xl">Scheduled buses</h1>
          <p className="mt-2 max-w-xl text-muted-foreground">
            Filter documented departures by route, direction, stop, and service day. This is a schedule, not a live
            tracker.
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to="/" data-jr-key="arrival-nav-link">
            <Button variant="ghost">
              <ArrowLeft className="size-4" /> Arrivals
            </Button>
          </Link>
          <Button data-jr-key="load-scheduled-buses" variant="outline" onClick={actions.loadView} disabled={loading}>
            Load schedule
          </Button>
          <Button data-jr-key="refresh-scheduled-buses" variant="outline" onClick={actions.refresh} disabled={loading}>
            <RefreshCw className={loading ? 'size-4 animate-spin' : 'size-4'} /> Refresh schedule
          </Button>
        </div>
      </header>
      <div className="mt-8">
        <ScheduleResults
          entries={snapshot.context.entries}
          lastUpdatedAt={snapshot.context.lastUpdatedAt}
          loading={loading}
          error={error}
          onRetry={actions.refresh}
        />
      </div>
      <div className="mt-12">
        <SchedulePublisher onPublish={actions.publish} busy={snapshot.matches('publishing')} />
      </div>
    </main>
  );
}
